<template>
  <div>
    <div class="ui hidden divider"></div>
    <a v-on:click="open" href="https://shifty.aragon.one" class="ui basic inverted button" v-bind:class="termsAccepted ? '' : 'disabled'">Buy with other cryptocurrencies</a>
  </div>
</template>

<script>
// import config from '../config'

export default {
  name: 'shifty',
  methods: {
    open(e) {
      e.preventDefault()
      const href = 'https://shifty.aragon.one'
      window.open(href, '1418115287605', 'width=400,height=600,toolbar=0,menubar=0,location=0,status=1,scrollbars=1,resizable=0')
      return false
    },
  },
  computed: {
    termsAccepted() {
      return this.$store.state.termsAccepted
    },
  },
}
</script>



// WEBPACK FOOTER //
// Shifty.vue?2badb14d